// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.profilepage_dashboard__f7faf {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.profilepage_dashboardContain__hkddW {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.profilepage_bodythemedark__U3bK3 .profilepage_dashboardContain__hkddW,
.profilepage_bodythemedark__U3bK3 .profilepage_dashboard__f7faf,
.profilepage_bodythemedark__U3bK3 .profilepage_cont2__vX6Z8 {
  background-Color: #0f1824;
}

.profilepage_top_header__ghfWd .profilepage_top_header_inner__tctlf {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.profilepage_cont2__vX6Z8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.profilepage_subLink__a0P7- svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.profilepage_cst_vendr__tibzk input {
  min-height: 35px !important;
}

.profilepage_cst_vendr__tibzk .profilepage_form-control__lahn6 {
  background-color: #f5f6fa;
  border: none;
}

.profilepage_footer__35p4i {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.profilepage_bodythemelight__yGXd9 {
  background-color: #fff;
  padding-top: 90px;
}

.profilepage_bodythemedark__U3bK3 {
  background-color: #132337;
  padding-top: 90px;
}

.profilepage_bodythemeNew__aGsXY {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.profilepage_headerthemelight__HG24f {
  background-color: #fff;
}

.profilepage_headerthemedark__6lim7 {
  background-color: #132337;
}

.profilepage_top_header__ghfWd {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.profilepage_menuthemelight__RZgav {
  background-color: #f5f6fa;
}

.profilepage_menuthemedark__Wr\\+AP {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.profilepage_menulinklight__ZWenu span {
  color: #666666 !important;
}

.profilepage_menulinklight__ZWenu a {
  color: #CBCBCB !important;
}

.profilepage_menulinklight__ZWenu:hover span,
.profilepage_menulinklight__ZWenu:hover a {
  color: #fff !important;
}

.profilepage_menulinkdarkSelected__ns9y7 {
  background-color: #1c2e45;
  color: #3b82f6;
}

.profilepage_menuthemelight__RZgav .profilepage_menulinklightSelected__bHyyK {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.profilepage_menulinkdark__33m\\+h {
  color: #92afd3 !important;
}

.profilepage_menulinklight__ZWenu:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.profilepage_menulinklight__ZWenu .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #CBCBCB !important;
}

.profilepage_menulinklight__ZWenu:hover .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #fff !important;
}

.profilepage_menulinkdark__33m\\+h .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #92afd3 !important;
}

.profilepage_menulinkdark__33m\\+h:hover .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #fff !important;
}

.profilepage_menulinklight__ZWenu:hover svg path,
.profilepage_menulinklightSelected__bHyyK svg path {
  fill: #fff !important;
}

.profilepage_menulinkdark__33m\\+h:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.profilepage_headinglight__\\+d\\+Kj {
  color: #60677e;
}

.profilepage_headingdark__U9OsA {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.profilepage_searchboxlight__\\+vXmM {
  background-color: #fff;
  border: none;
}

.profilepage_searchboxdark__PlzjR {
  background-color: #132337;
  color: #fff;
  border: none;
}

.profilepage_searchboxdark__PlzjR::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.profilepage_tableheadlight__N\\+1m0 {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.profilepage_tableheadlight__N\\+1m0 th {
  color: #fff;
}

thead .profilepage_tableheadlight__N\\+1m0 th:first-child,
thead .profilepage_tableheaddark__pzdGJ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .profilepage_tableheadlight__N\\+1m0 th:last-child,
thead .profilepage_tableheaddark__pzdGJ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.profilepage_table__PkPOM.profilepage_table-borderless__3OWpu {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.profilepage_tableheaddark__pzdGJ {
  background-color: #132337;
  color: #fff;
}

.profilepage_table-borderless__3OWpu tr:nth-child(even) {
  background-color: #F9FAFB;
}

.profilepage_table-borderless__3OWpu .profilepage_left-section__yST00 {
  padding-top: 10px;
}

.profilepage_tablebodylight__G8aH6 td,
.profilepage_tablebodydark__aL83x td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.profilepage_tablebodylight__G8aH6 {
  background-color: #fff;
}
.profilepage_tablebodylight__G8aH6:hover {
  background-color: #fff;
  cursor: auto;
}
.profilepage_tablebodylight__G8aH6 p {
  line-height: 24px;
}

.profilepage_tablebodydark__aL83x {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.profilepage_tablebodydark__aL83x:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.profilepage_paginationlight__JC8Io {
  color: #60677e !important;
  font-size: 13px !important;
}

.profilepage_paginationdark__47-Us {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.profilepage_formthemelight__x\\+moB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.profilepage_formthemedark__cHqTr {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.profilepage_formthemedark__cHqTr ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.profilepage_viewformlight__k\\+6pb {
  background-color: #f3f6f9;
}

.profilepage_permissionboxlight__LHtZE {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.profilepage_permissionboxdark__B-n-5 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.profilepage_errormsgclr__KHi1K {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.profilepage_graphclrlight__afP5N {
  background-color: #fff;
}

.profilepage_graphclrdark__q0mUw {
  background-color: #132337;
}

/* 
Counter theme
*/
#profilepage_card1bglight__TdFoy {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#profilepage_card1bgdark__LnXNf {
  background: #392f28;
}

#profilepage_card2bglight__fuVfR {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#profilepage_card2bgdark__aYkis {
  background: #1c3238;
}

#profilepage_card3bglight__Aaxrz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#profilepage_card3bgdark__Jk5Oj {
  background: #3a2434;
}

#profilepage_card4bglight__Kgj-s {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#profilepage_card4bgdark__d9yP4 {
  background: #2f264f;
}

#profilepage_card1bgdark__LnXNf a,
#profilepage_card1bgdark__LnXNf p,
#profilepage_card2bgdark__aYkis a,
#profilepage_card2bgdark__aYkis p,
#profilepage_card3bgdark__Jk5Oj a,
#profilepage_card3bgdark__Jk5Oj p,
#profilepage_card4bgdark__d9yP4 a,
#profilepage_card4bgdark__d9yP4 p {
  color: #fff;
}

/* 
Action button theme
*/
.profilepage_actionbtnlight__oe7Kr {
  color: rgba(70, 71, 91, 0.8705882353);
}

.profilepage_actionbtndark__D07fP {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.profilepage_profiledropdownlight__\\+l7Jy {
  background-color: #fff;
}

.profilepage_profiledropdowndark__2Nv11 {
  background-color: #151521;
}

.profilepage_settingsection__GDOL5 #profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_savebtn__pa-Rp {
  background-color: #3b82f6;
  color: #fff;
}

#profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_savebtn__pa-Rp {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_profile_conatiner__n\\+Sap {
  border-radius: 5px !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_ag-theme-alpine__t\\+UOw .profilepage_ag-row__qd5R6 {
  background: #000 !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_formbtn__JcqVp {
  background-color: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_formbtn__JcqVp:hover {
  background-color: #2563eb;
}

.profilepage_bodythemedark__U3bK3 .profilepage_resetbtn__Qq1fD {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_resetbtn__Qq1fD:hover {
  background-color: #3b82f6;
}

.profilepage_headingdark__U9OsA span {
  background-color: #132337;
}

.profilepage_resetbtn__Qq1fD {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.profilepage_resetbtn__Qq1fD:hover,
.profilepage_resetbtn__Qq1fD:active,
.profilepage_resetbtn__Qq1fD:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.profilepage_addBtn__lX2tJ {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.profilepage_addDltBtn__51fXq {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.profilepage_addbtnlight__6xH2o {
  background-color: #38A169;
}

.profilepage_addbtndark__KT3sY {
  background-color: #3b82f6;
}

.profilepage_addbtndark__KT3sY:hover {
  background-color: #2563eb;
}

.profilepage_formthemedark__cHqTr label {
  color: #92afd3;
}

.profilepage_addBtn__lX2tJ svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.profilepage_addBtn__lX2tJ:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.profilepage_cust_addBtn__kVlDz.profilepage_addBtn__lX2tJ svg {
  top: 2px;
}

.profilepage_deleteBtn__hnEUw {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilepage_deleteBtn__hnEUw {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilepage_deleteBtn__hnEUw:active,
.profilepage_deleteBtn__hnEUw:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.profilepage_deleteBtn__hnEUw svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.profilepage_deleteBtn__hnEUw:hover,
.profilepage_deleteBtn__hnEUw:active,
.profilepage_deleteBtn__hnEUw:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.profilepage_confirmBtn__HkdQl {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.profilepage_confirmBtn__HkdQl:hover,
.profilepage_confirmBtn__HkdQl:active,
.profilepage_confirmBtn__HkdQl:focus {
  background-color: #0f1824 !important;
}

.profilepage_confirmBtn__HkdQl svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.profilepage_delPopContainer__4yMmw .profilepage_modal-body__nGjkw {
  padding: 35px;
  text-align: center;
}

.profilepage_delPopContainer__4yMmw .profilepage_delet_icon__UqIhu {
  margin-bottom: 11px;
}

.profilepage_delPopContainer__4yMmw p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.profilepage_arrowback__70GXL svg {
  fill: #000;
}

.profilepage_bodythemedark__U3bK3 .profilepage_arrowback__70GXL {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_arrowback__70GXL svg {
  fill: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_drpdwn_btn__o1f9m {
  background-color: #132337;
}

.profilepage_bodythemedark__U3bK3 .profilepage_empname__qjhb9 {
  color: #92afd3 !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_navitemli__SMmg1 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingsgeneral__rW4Tl,
.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingslinks__MsUdd:hover {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingslinks__MsUdd {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- {
  background-color: #1c2e45;
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- ul li a,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ h5 {
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- ul li a:hover,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ:hover {
  background-color: #132337;
  color: #fff;
}

.profilepage_dropdown_item__CrmAQ:active {
  background-color: #F5F6FA;
}

.profilepage_profile_arrrow_dwn__r\\+RYo {
  stroke: #132337;
}

.profilepage_headerthemedark__6lim7 .profilepage_profile_arrrow_dwn__r\\+RYo {
  stroke: #fff;
}

.profilepage_dateinputbox1__kTTaR input,
.profilepage_dateinputbox1__kTTaR span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.profilepage_delPopContainer__4yMmw .profilepage_modal-content__HvPTR {
  border-radius: 10px;
  min-width: 399px;
}

.profilepage_larg_model__x9iML .profilepage_modal-dialog__9G6zp {
  max-width: 100% !important;
}

.profilepage_larg_model__x9iML .profilepage_modal-content__HvPTR {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.profilepage_larg_model__x9iML .profilepage_modal-header__H4KmY {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .profilepage_btn-primary__Kkrn8:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.profilepage_form-select__e3zwo {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .profilepage_CustomTable_tableheadlight__HuHZw__2\\+hA8 th:first-child,
thead .profilepage_CustomTable_tableheaddark__nwqb4__35h0Z th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .profilepage_tableheadlight__N\\+1m0 th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .profilepage_dashboard__f7faf {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .profilepage_cont2__vX6Z8 {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .profilepage_sectionright__\\+Mbgv {
    float: unset !important;
  }
  .profilepage_dashboard__f7faf {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .profilepage_cont2__vX6Z8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .profilepage_bodythemelight__yGXd9,
.profilepage_bodythemedark__U3bK3 {
    padding-top: 110px;
  }
  .profilepage_delPopContainer__4yMmw .profilepage_modal-content__HvPTR {
    min-width: 100%;
  }
  .profilepage_delPopContainer__4yMmw .profilepage_modal-body__nGjkw {
    padding: 15px;
  }
  .profilepage_larg_model__x9iML .profilepage_modal-content__HvPTR {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .profilepage_exer_modal_contain__oT7Kn .profilepage_modal-dialog__9G6zp {
    max-width: 1055px;
  }
  .profilepage_delPopContainer__4yMmw .profilepage_modal-dialog__9G6zp {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.profilepage_active_show_outer__J7jht h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .profilepage_active_show_outer__J7jht h2 {
    margin-top: 15px;
  }
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 {
  width: 100%;
  display: block;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_img__pS-y- {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_img__pS-y- {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_img__pS-y- img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 {
  width: 100%;
  display: block;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 svg {
  flex-shrink: 0;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 .profilepage_act_box_bdg__TpkTf {
  width: 100%;
  margin-bottom: 12px;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 .profilepage_act_box_bdg__TpkTf span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 .profilepage_act_box_bdg__TpkTf .profilepage_sold__V0\\+MT {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.profilepage_active_show_outer__J7jht .profilepage_active_show_inner__ohbQ0 .profilepage_act_box_cnt__fRUZ0 p .profilepage_timezone_code_pill__P0EY8 {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#profilepage_attent_details_row1__tyyri {
  margin-bottom: 0 !important;
}

.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_l__\\+T6cG img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs {
  flex: 1 1;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB .profilepage_attent_details_row_box__enOqX {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB .profilepage_attent_details_row_box__enOqX {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB .profilepage_attent_details_row_box__enOqX {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB .profilepage_attent_details_row_box__enOqX p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row__WFDRB .profilepage_attent_details_row_box__enOqX h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row_last__2nHlv {
  margin-bottom: 0px !important;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row_last__2nHlv.profilepage_interesting_fact__z6ebN {
  padding-top: 30px;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row_last__2nHlv.profilepage_interesting_fact__z6ebN .profilepage_attent_details_row_box__enOqX {
  width: 100%;
}
.profilepage_attent_details__Y3MhN .profilepage_attent_details_inner__gLYjp .profilepage_attent_details_inner_r__ZgqWs .profilepage_attent_details_row_last__2nHlv.profilepage_interesting_fact__z6ebN .profilepage_attent_details_row_box__enOqX h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.profilepage_showbox_sec__SZjC8 {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .profilepage_showbox_sec__SZjC8 {
    justify-content: center;
  }
}

.profilepage_show_box_main__QLgqg {
  margin: 10px 0px;
}
.profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5 {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5 {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5 {
    min-height: 500px;
    width: 200px !important;
  }
}
.profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5 img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5 img {
    max-height: 300px !important;
  }
}
.profilepage_show_box_main__QLgqg .profilepage_show_box__x8hO5:last-child {
  margin-right: 0px !important;
}
.profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft {
    width: 250px !important;
  }
}
.profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft img {
    max-height: 350px !important;
  }
}
.profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .profilepage_show_box_main__QLgqg .profilepage_no_show_box__P6Lft h6 {
    font-size: 20px;
  }
}

.profilepage_attent_flex__MUvhP {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.profilepage_attent_flex__MUvhP h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.profilepage_settingsection__GDOL5 {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.profilepage_settingsection__GDOL5 #profilepage_settingsheading__eY9X1 {
  font-size: 18px;
}
.profilepage_settingsection__GDOL5 .profilepage_settingslinks__MsUdd {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
}
.profilepage_settingsection__GDOL5 .profilepage_settingsgeneral__rW4Tl {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 .profilepage_settingslinks__MsUdd:hover {
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 .profilepage_settingsgeneral__rW4Tl:hover {
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 #profilepage_layoutnav__wq9JM {
  border-radius: 5px;
}

#profilepage_addform__DRU9M {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#profilepage_addform__DRU9M #profilepage_addheading__-dxn3 {
  font-size: 18px;
  margin-left: 10px;
}
#profilepage_addform__DRU9M .profilepage_profilepicdiv__pd\\+Tp {
  border-radius: 5px;
}
#profilepage_addform__DRU9M .profilepage_profilepic__LNywb {
  width: 100%;
  height: auto;
  border-radius: 5px;
}
#profilepage_addform__DRU9M .profilepage_penicon__lFo6n {
  margin-right: 5px;
}
#profilepage_addform__DRU9M .profilepage_namesection__iSS9i {
  display: inline-block;
  margin-left: 20px;
}
#profilepage_addform__DRU9M .profilepage_profilename__elZhR {
  font-size: 16px;
  margin-top: 30px;
}
#profilepage_addform__DRU9M .profilepage_profileedit__GF2gr {
  font-size: 14px;
  text-decoration: none;
  color: #fff;
  background-color: #131F43;
  padding: 10px;
  border-radius: 4px;
}
#profilepage_addform__DRU9M .profilepage_editbtntop__vydyF {
  float: right;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu {
  padding: 0px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu .profilepage_title__edgfj {
  font-size: 13px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 7px;
  display: block;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu.profilepage_viewformlight__k\\+6pb .profilepage_empname__qjhb9 {
  color: #131F43;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu .profilepage_empname__qjhb9 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  padding-bottom: 0px;
  word-break: break-word;
}

.profilepage_viewformlight__k\\+6pb {
  background-color: transparent;
}

.profilepage_bodythemedark__U3bK3 #profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_profileedit__GF2gr {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_bodythemelight__yGXd9 #profilepage_addform__DRU9M.profilepage_formthemelight__x\\+moB .profilepage_profileedit__GF2gr {
  background-color: #131F43;
  color: #fff;
}

.profilepage_formthemedark__cHqTr #profilepage_empdiv__Q3gCu .profilepage_title__edgfj {
  color: #fff !important;
}

@media only screen and (max-width: 992px) {
  .profilepage_editbtntop__vydyF {
    float: left !important;
  }
}
@media only screen and (max-width: 878px) {
  #profilepage_layoutnav__wq9JM {
    display: flex !important;
  }
  .profilepage_settingslinks__MsUdd {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  #profilepage_addform__DRU9M .profilepage_profilepic__LNywb {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 510px) {
  .profilepage_settingslinks__MsUdd {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 495px) {
  .profilepage_settingslinks__MsUdd {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 331px) {
  .profilepage_settingsgeneral__rW4Tl, .profilepage_settingslinks__MsUdd {
    padding: 12px !important;
  }
  .profilepage_namesection__iSS9i {
    margin-left: 5px !important;
  }
}
@media only screen and (max-width: 600px) {
  #profilepage_dashboardcont2__-ZZ-P {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/profile/profilepage.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AA3lCA;EACI,mBAAA;EACA,oBAAA;AA8lCJ;AA5lCI;EACI,eAAA;AA8lCR;AA5lCI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AA8lCR;AA3lCI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WDoCM;ECnCN,yBDgDW;AC6iCnB;AAzlCI;EACI,WD8BM;EC7BN,yBD0CW;ACijCnB;AAxlCI;EACI,WDyBM;ECxBN,yBDqCW;ACqjCnB;AAvlCM;EACE,kBAAA;AAylCR;;AAplCY;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAulChB;AAtlCgB;EACI,eAAA;EACA,iBAAA;AAwlCpB;AAtlCgB;EACI,kBAAA;AAwlCpB;AAtlCgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAwlCpB;AAtlCgB;EACI,iBAAA;AAwlCpB;AArlCgB;EACI,qBAAA;EACA,iBAAA;AAulCpB;AAplCgB;EACI,eAAA;EACA,gBAAA;AAslCpB;AAplCgB;EACI,eAAA;EAEA,qBAAA;EACA,WDnBN;ECoBM,yBDPD;ECQC,aAAA;EACA,kBAAA;AAqlCpB;AAllCgB;EACI,YAAA;AAolCpB;AAhlCoB;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AAklCxB;AAhlCwB;EACI,eAAA;EACA,gBDxFZ;ECyFY,cDjFX;ECkFW,kBAAA;EACA,cAAA;AAklC5B;AA/kC4B;EACI,cDzFhB;AC0qChB;AA9kCwB;EACI,eAAA;EACA,gBDpGZ;ECqGY,WDlDd;ECmDc,mBAAA;EACA,sBAAA;AAglC5B;;AA3kCA;EACI,6BAAA;AA8kCJ;;AA3kCA;EACI,yBD/EgB;ECgFhB,WD/DU;AC6oCd;;AA3kCA;EACI,yBDhHY;ECiHZ,WDpEU;ACkpCd;;AA3kCA;EACI,sBAAA;AA8kCJ;;AAxjCC;EACG;IACG,sBAAA;EA2jCL;AACF;AAxjCA;EACI;IACI,wBAAA;EA0jCN;EAxjCI;IACE,4BAAA;IACA,0BAAA;EA0jCN;EAxjCE;IACI,4BAAA;IACA,0BAAA;EA0jCN;EAxjCE;IACI,mBAAA;EA0jCN;AACF;AAvjCA;EACM;IACE,4BAAA;IACA,0BAAA;EAyjCN;EAvjCE;IACI,4BAAA;IACA,0BAAA;EAyjCN;AACF;AAtjCA;EACI;IACE,4BAAA;IACA,0BAAA;EAwjCJ;EAtjCA;IACI,4BAAA;IACA,0BAAA;EAwjCJ;AACF;AApjCA;EACE;IACE,wBAAA;EAsjCF;EApjCA;IACE,2BAAA;EAsjCF;AACF;AA/iCA;EACI;IACI,wBD7HI;IC8HJ,UD7HG;IC8HH,kBAAA;IACA,aDrIW;ECsrCjB;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n    }\n    .settingslinks{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n    }\n\n    .settingsgeneral{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n\n    \n    .settingslinks:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n    \n    .settingsgeneral:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n      }\n\n      #layoutnav{\n        border-radius: 5px;\n      }\n\n}\n                \n            #addform{\n                width: 100%;\n                border-radius: 5px;\n                margin-top: 30px;\n                padding-bottom:30px;\n                #addheading{\n                    font-size: 18px;\n                    margin-left: 10px;\n                }\n                .profilepicdiv{\n                    border-radius: 5px;\n                }\n                .profilepic{\n                    width: 100%;\n                    height: auto;\n                    border-radius: 5px;\n                }\n                .penicon{\n                    margin-right: 5px;\n                }\n\n                .namesection{\n                    display: inline-block;\n                    margin-left: 20px;\n                }\n\n                .profilename{\n                    font-size: 16px;\n                    margin-top: 30px;\n                }\n                .profileedit{\n                    font-size: 14px;\n                     \n                    text-decoration: none;\n                    color: $white-color;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    border-radius: 4px;\n                }\n            \n                .editbtntop{\n                    float: right;\n                }\n\n\n                    #empdiv{\n                        padding:0px 0px 0px 15px;\n                        margin-bottom: 10px;\n                        border-radius: 5px;\n\n                        .title{\n                            font-size: 13px;\n                            font-weight: $font-semiBold;\n                            color: $text-graycolor;\n                            margin-bottom: 7px;\n                            display: block;\n                        }\n                        &.viewformlight {\n                            .empname{\n                                color: $primary-color;\n                            }\n                        }\n                        .empname{\n                            font-size: 16px;\n                            font-weight: $font-semiBold;\n                            color: $white-color;\n                            padding-bottom:0px;\n                            word-break: break-word;\n                        }\n                    }\n            }\n\n.viewformlight {\n    background-color: transparent;\n}\n\n.bodythemedark #addform.formthemedark .profileedit {\n    background-color: $addBtn-dark-blue;\n    color: $white-color;\n}\n\n.bodythemelight #addform.formthemelight .profileedit {\n    background-color: $primary-color;\n    color: $white-color;\n}\n\n.formthemedark #empdiv .title {\n    color: $white-color !important;\n}\n  \n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 40px !important;\n//     }\n//     }\n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 20px !important;\n//     }\n// }\n\n// @media only screen and (max-width: 1200px) {\n//     .editbtntop{\n//         margin-left: 50px !important;\n//     }\n// }\n\n @media only screen and (max-width: 992px) {\n    .editbtntop{\n       float: left !important;\n    }\n}\n\n@media only screen and (max-width: 878px) {\n    #layoutnav{\n        display: flex !important;\n      }\n      .settingslinks{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    .settingsgeneral{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    #addform .profilepic{ \n        margin-bottom: 30px;\n    }\n}\n\n@media only screen and (max-width: 510px) {\n      .settingslinks{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n    .settingsgeneral{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n}\n\n@media only screen and (max-width: 495px) {\n    .settingslinks{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n  .settingsgeneral{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n}\n\n\n@media only screen and (max-width: 331px) {\n  .settingsgeneral,  .settingslinks{\n    padding: 12px !important;\n  }\n  .namesection{\n    margin-left: 5px !important;\n\n}\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `profilepage_dashboard__f7faf`,
	"dashboardContain": `profilepage_dashboardContain__hkddW`,
	"bodythemedark": `profilepage_bodythemedark__U3bK3`,
	"cont2": `profilepage_cont2__vX6Z8`,
	"top_header": `profilepage_top_header__ghfWd`,
	"top_header_inner": `profilepage_top_header_inner__tctlf`,
	"subLink": `profilepage_subLink__a0P7-`,
	"cst_vendr": `profilepage_cst_vendr__tibzk`,
	"form-control": `profilepage_form-control__lahn6`,
	"footer": `profilepage_footer__35p4i`,
	"bodythemelight": `profilepage_bodythemelight__yGXd9`,
	"bodythemeNew": `profilepage_bodythemeNew__aGsXY`,
	"headerthemelight": `profilepage_headerthemelight__HG24f`,
	"headerthemedark": `profilepage_headerthemedark__6lim7`,
	"menuthemelight": `profilepage_menuthemelight__RZgav`,
	"menuthemedark": `profilepage_menuthemedark__Wr+AP`,
	"menulinklight": `profilepage_menulinklight__ZWenu`,
	"menulinkdarkSelected": `profilepage_menulinkdarkSelected__ns9y7`,
	"menulinklightSelected": `profilepage_menulinklightSelected__bHyyK`,
	"menulinkdark": `profilepage_menulinkdark__33m+h`,
	"sub_arrow": `profilepage_sub_arrow__5Zuyi`,
	"headinglight": `profilepage_headinglight__+d+Kj`,
	"headingdark": `profilepage_headingdark__U9OsA`,
	"searchboxlight": `profilepage_searchboxlight__+vXmM`,
	"searchboxdark": `profilepage_searchboxdark__PlzjR`,
	"tableheadlight": `profilepage_tableheadlight__N+1m0`,
	"tableheaddark": `profilepage_tableheaddark__pzdGJ`,
	"table": `profilepage_table__PkPOM`,
	"table-borderless": `profilepage_table-borderless__3OWpu`,
	"left-section": `profilepage_left-section__yST00`,
	"tablebodylight": `profilepage_tablebodylight__G8aH6`,
	"tablebodydark": `profilepage_tablebodydark__aL83x`,
	"paginationlight": `profilepage_paginationlight__JC8Io`,
	"paginationdark": `profilepage_paginationdark__47-Us`,
	"formthemelight": `profilepage_formthemelight__x+moB`,
	"formthemedark": `profilepage_formthemedark__cHqTr`,
	"viewformlight": `profilepage_viewformlight__k+6pb`,
	"permissionboxlight": `profilepage_permissionboxlight__LHtZE`,
	"permissionboxdark": `profilepage_permissionboxdark__B-n-5`,
	"errormsgclr": `profilepage_errormsgclr__KHi1K`,
	"graphclrlight": `profilepage_graphclrlight__afP5N`,
	"graphclrdark": `profilepage_graphclrdark__q0mUw`,
	"card1bglight": `profilepage_card1bglight__TdFoy`,
	"card1bgdark": `profilepage_card1bgdark__LnXNf`,
	"card2bglight": `profilepage_card2bglight__fuVfR`,
	"card2bgdark": `profilepage_card2bgdark__aYkis`,
	"card3bglight": `profilepage_card3bglight__Aaxrz`,
	"card3bgdark": `profilepage_card3bgdark__Jk5Oj`,
	"card4bglight": `profilepage_card4bglight__Kgj-s`,
	"card4bgdark": `profilepage_card4bgdark__d9yP4`,
	"actionbtnlight": `profilepage_actionbtnlight__oe7Kr`,
	"actionbtndark": `profilepage_actionbtndark__D07fP`,
	"profiledropdownlight": `profilepage_profiledropdownlight__+l7Jy`,
	"profiledropdowndark": `profilepage_profiledropdowndark__2Nv11`,
	"settingsection": `profilepage_settingsection__GDOL5`,
	"addform": `profilepage_addform__DRU9M`,
	"savebtn": `profilepage_savebtn__pa-Rp`,
	"profile_conatiner": `profilepage_profile_conatiner__n+Sap`,
	"ag-theme-alpine": `profilepage_ag-theme-alpine__t+UOw`,
	"ag-row": `profilepage_ag-row__qd5R6`,
	"formbtn": `profilepage_formbtn__JcqVp`,
	"resetbtn": `profilepage_resetbtn__Qq1fD`,
	"addBtn": `profilepage_addBtn__lX2tJ`,
	"addDltBtn": `profilepage_addDltBtn__51fXq`,
	"addbtnlight": `profilepage_addbtnlight__6xH2o`,
	"addbtndark": `profilepage_addbtndark__KT3sY`,
	"cust_addBtn": `profilepage_cust_addBtn__kVlDz`,
	"deleteBtn": `profilepage_deleteBtn__hnEUw`,
	"confirmBtn": `profilepage_confirmBtn__HkdQl`,
	"delPopContainer": `profilepage_delPopContainer__4yMmw`,
	"modal-body": `profilepage_modal-body__nGjkw`,
	"delet_icon": `profilepage_delet_icon__UqIhu`,
	"arrowback": `profilepage_arrowback__70GXL`,
	"drpdwn_btn": `profilepage_drpdwn_btn__o1f9m`,
	"empname": `profilepage_empname__qjhb9`,
	"navitemli": `profilepage_navitemli__SMmg1`,
	"tabnavli": `profilepage_tabnavli__3ewNE`,
	"settingsgeneral": `profilepage_settingsgeneral__rW4Tl`,
	"settingslinks": `profilepage_settingslinks__MsUdd`,
	"dropdown_menu_contain": `profilepage_dropdown_menu_contain__iir6-`,
	"dropdown_item": `profilepage_dropdown_item__CrmAQ`,
	"profile_arrrow_dwn": `profilepage_profile_arrrow_dwn__r+RYo`,
	"dateinputbox1": `profilepage_dateinputbox1__kTTaR`,
	"modal-content": `profilepage_modal-content__HvPTR`,
	"larg_model": `profilepage_larg_model__x9iML`,
	"modal-dialog": `profilepage_modal-dialog__9G6zp`,
	"modal-header": `profilepage_modal-header__H4KmY`,
	"btn-primary": `profilepage_btn-primary__Kkrn8`,
	"form-select": `profilepage_form-select__e3zwo`,
	"CustomTable_tableheadlight__HuHZw": `profilepage_CustomTable_tableheadlight__HuHZw__2+hA8`,
	"CustomTable_tableheaddark__nwqb4": `profilepage_CustomTable_tableheaddark__nwqb4__35h0Z`,
	"sectionright": `profilepage_sectionright__+Mbgv`,
	"exer_modal_contain": `profilepage_exer_modal_contain__oT7Kn`,
	"active_show_outer": `profilepage_active_show_outer__J7jht`,
	"active_show_inner": `profilepage_active_show_inner__ohbQ0`,
	"act_box_img": `profilepage_act_box_img__pS-y-`,
	"act_box_cnt": `profilepage_act_box_cnt__fRUZ0`,
	"act_box_bdg": `profilepage_act_box_bdg__TpkTf`,
	"sold": `profilepage_sold__V0+MT`,
	"timezone_code_pill": `profilepage_timezone_code_pill__P0EY8`,
	"attent_details_row1": `profilepage_attent_details_row1__tyyri`,
	"attent_details": `profilepage_attent_details__Y3MhN`,
	"attent_details_inner": `profilepage_attent_details_inner__gLYjp`,
	"attent_details_inner_l": `profilepage_attent_details_inner_l__+T6cG`,
	"attent_details_inner_r": `profilepage_attent_details_inner_r__ZgqWs`,
	"attent_details_row": `profilepage_attent_details_row__WFDRB`,
	"attent_details_row_box": `profilepage_attent_details_row_box__enOqX`,
	"attent_details_row_last": `profilepage_attent_details_row_last__2nHlv`,
	"interesting_fact": `profilepage_interesting_fact__z6ebN`,
	"showbox_sec": `profilepage_showbox_sec__SZjC8`,
	"show_box_main": `profilepage_show_box_main__QLgqg`,
	"show_box": `profilepage_show_box__x8hO5`,
	"no_show_box": `profilepage_no_show_box__P6Lft`,
	"attent_flex": `profilepage_attent_flex__MUvhP`,
	"settingsheading": `profilepage_settingsheading__eY9X1`,
	"layoutnav": `profilepage_layoutnav__wq9JM`,
	"addheading": `profilepage_addheading__-dxn3`,
	"profilepicdiv": `profilepage_profilepicdiv__pd+Tp`,
	"profilepic": `profilepage_profilepic__LNywb`,
	"penicon": `profilepage_penicon__lFo6n`,
	"namesection": `profilepage_namesection__iSS9i`,
	"profilename": `profilepage_profilename__elZhR`,
	"profileedit": `profilepage_profileedit__GF2gr`,
	"editbtntop": `profilepage_editbtntop__vydyF`,
	"empdiv": `profilepage_empdiv__Q3gCu`,
	"title": `profilepage_title__edgfj`,
	"dashboardcont2": `profilepage_dashboardcont2__-ZZ-P`
};
export default ___CSS_LOADER_EXPORT___;
